import React from "react";
import MIcon from "../../icons/MIcon";

/**
 * CardHeader — the icon + title + subtitle block used at the top of every
 * dashboard card (calls per day, calls by business, AI usage, ...).
 *
 * Style intentionally identical to the existing `flat-card` cards in
 * Settings.js / CreateOrganization.js so the dashboard blends in.
 */
const CardHeader = ({ icon, title, subtitle }) => (
  <div className="flex items-start gap-3 mb-5">
    <div className="w-10 h-10 rounded-lg bg-brand/10 dark:bg-brand/15 flex items-center justify-center text-brand dark:text-brand shrink-0">
      <MIcon name={icon} />
    </div>
    <div>
      <h2 className="font-display text-base font-semibold text-on-surface-light dark:text-on-surface">
        {title}
      </h2>
      {subtitle && (
        <p className="text-xs text-on-surface-light-variant dark:text-on-surface-variant">
          {subtitle}
        </p>
      )}
    </div>
  </div>
);

export default CardHeader;
